import { render } from "./ReportsPageTableColumnSize.vue?vue&type=template&id=3d6719a2&ts=true"
import script from "./ReportsPageTableColumnSize.vue?vue&type=script&lang=ts"
export * from "./ReportsPageTableColumnSize.vue?vue&type=script&lang=ts"

import "./ReportsPageTableColumnSize.vue?vue&type=style&index=0&id=3d6719a2&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__